
// import React, { useState, useEffect } from 'react';
// import {
//   Box,
//   Typography,
//   Pagination,
//   Button,
//   Card,
//   CardContent,
//   Snackbar,
//   Alert,
// } from '@mui/material';
// import { useSelector } from 'react-redux';
// import axios from 'axios';
// import VisibilityIcon from '@mui/icons-material/Visibility';
// import ShareIcon from '@mui/icons-material/Share';
// import FavoriteIcon from '@mui/icons-material/Favorite';
// import Loader from '../../../Loader/Loader';
// import { selectUser } from '../../../Commonlibs/userSlice';
// import { useNavigate } from 'react-router-dom';

// const outfitFontStyle = {
//   fontFamily: 'Outfit, sans-serif',
// };

// const ProfileWish = () => {
//   const [favorites, setFavorites] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
  
//   const [snackbar, setSnackbar] = useState({
//     open: false,
//     message: '',
//     severity: 'success'
//   });
  
//   const [page, setPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(0);
//   const itemsPerPage = 6;
  
//   const navigate = useNavigate();
//   const user = useSelector(selectUser);
//   const buyerId = user?.id;

//   useEffect(() => {
//     const fetchFavorites = async () => {
//       if (!buyerId) {
//         setLoading(false);
//         return;
//       }
      
//       try {
//         setLoading(true);
//         const response = await axios.get(
//           `https://propertydealstalk.com/api/buyer/getFavoritesByBuyerId?buyer_id=${buyerId}`
//         );
        
//         if (response.data.statusCode === 200) {
//           // Sort favorites by latest first
//           const sortedFavorites = response.data.result.sort((a, b) => {
//             const dateA = new Date(b.property?.updatedAt || b.property?.createdAt || 0);
//             const dateB = new Date(a.property?.updatedAt || a.property?.createdAt || 0);
//             return dateA - dateB;
//           });
          
//           setFavorites(sortedFavorites);
//           setTotalPages(Math.ceil(sortedFavorites.length / itemsPerPage));
//         } else {
//           setError('Failed to fetch favorites');
//         }
//       } catch (err) {
//         setError('Error fetching favorites: ' + err.message);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchFavorites();
//   }, [buyerId]);

//   // ✅ FIXED: Function to check if property has a valid image
//   const hasValidImage = (property) => {
//     if (!property) return false;
    
//     // Check primary_image field (from your API response)
//     if (property.primary_image && 
//         property.primary_image.length > 50 &&
//         property.primary_image.startsWith('/9j/')) {
//       return true;
//     }

//     // Check image field
//     if (property.image && 
//         property.image.length > 50 && 
//         !property.image.startsWith('iVBORw0KGgo')) {
//       return true;
//     }

//     // Check images field
//     if (property.images) {
//       if (typeof property.images === 'string' && property.images.length > 50) {
//         return true;
//       }
//       if (Array.isArray(property.images) && property.images.length > 0) {
//         return true;
//       }
//     }

//     return false;
//   };

//   // ✅ FIXED: Function to get property image
//   const getPropertyImage = (property) => {
//     if (!property) return null;
    
//     // Priority 1: Check primary_image field (from your API response)
//     if (property.primary_image && property.primary_image.length > 50) {
//       // Check if it already has data URL prefix
//       if (property.primary_image.startsWith('data:image')) {
//         return property.primary_image;
//       }
//       // Add data URL prefix for base64
//       return `data:image/jpeg;base64,${property.primary_image}`;
//     }

//     // Priority 2: Check image field
//     if (property.image && 
//         property.image.length > 50 && 
//         !property.image.startsWith('iVBORw0KGgo')) {
//       if (property.image.startsWith('data:image')) {
//         return property.image;
//       }
//       return `data:image/jpeg;base64,${property.image}`;
//     }

//     // Priority 3: Check images field
//     if (property.images) {
//       if (typeof property.images === 'string' && property.images.length > 50) {
//         if (property.images.startsWith('data:image')) {
//           return property.images;
//         }
//         return `data:image/jpeg;base64,${property.images}`;
//       }
//       if (Array.isArray(property.images) && property.images.length > 0) {
//         const firstImage = property.images[0];
//         if (firstImage.startsWith('data:image')) {
//           return firstImage;
//         }
//         return `data:image/jpeg;base64,${firstImage}`;
//       }
//     }

//     return null;
//   };

//   // Function to format time ago
//   const getTimeAgo = (dateString) => {
//     if (!dateString) return '';
    
//     const date = new Date(dateString);
//     const now = new Date();
//     const diffInSeconds = Math.floor((now - date) / 1000);
    
//     const intervals = {
//       y: 31536000,
//       mo: 2592000,
//       w: 604800,
//       d: 86400,
//       h: 3600,
//       m: 60,
//       s: 1
//     };
    
//     for (const [key, value] of Object.entries(intervals)) {
//       const interval = Math.floor(diffInSeconds / value);
//       if (interval >= 1) {
//         return `${interval}${key} ago`;
//       }
//     }
    
//     return 'just now';
//   };

//   // Handle remove favorite
//   const handleRemoveFavorite = async (propertyId, event) => {
//     event.stopPropagation();
    
//     try {
//       const response = await axios.post(
//         'https://www.propertydealstalk.com/api/buyer/removeFavorite',
//         {
//           buyer_id: buyerId,
//           property_id: propertyId
//         }
//       );
      
//       if (response.data.statusCode === 200) {
//         const updatedFavorites = favorites.filter(
//           item => item.property.id !== propertyId
//         );
//         setFavorites(updatedFavorites);
        
//         const newTotalPages = Math.ceil(updatedFavorites.length / itemsPerPage);
//         setTotalPages(newTotalPages);
        
//         if (page > newTotalPages && page > 1) {
//           setPage(newTotalPages);
//         }
        
//         setSnackbar({
//           open: true,
//           message: 'Property removed from favorites successfully',
//           severity: 'success'
//         });
//       } else {
//         setSnackbar({
//           open: true,
//           message: 'Failed to remove property from favorites',
//           severity: 'error'
//         });
//       }
//     } catch (err) {
//       setSnackbar({
//         open: true,
//         message: 'Error removing favorite: ' + err.message,
//         severity: 'error'
//       });
//     }
//   };

//   const handleCloseSnackbar = () => {
//     setSnackbar({ ...snackbar, open: false });
//   };

//   const getCurrentPageItems = () => {
//     const startIndex = (page - 1) * itemsPerPage;
//     const endIndex = startIndex + itemsPerPage;
//     return favorites.slice(startIndex, endIndex);
//   };

//   const handlePageChange = (event, value) => {
//     setPage(value);
//     window.scrollTo({ top: 0, behavior: 'smooth' });
//   };

//   const formatCurrency = (amount, currency = '₹') => {
//     if (!amount) return null;
//     return `${currency}${Number(amount).toLocaleString()}`;
//   };

//   const handleViewProperty = (propertyId) => {
//     navigate(`/view/${propertyId}`);
//   };

//   const handleShareProperty = (propertyId, event) => {
//     event.stopPropagation();
//     const publicUrl = `${window.location.origin}/view/${propertyId}?shared=true`;
    
//     navigator.clipboard.writeText(publicUrl).then(() => {
//       setSnackbar({
//         open: true,
//         message: 'Property link copied to clipboard!',
//         severity: 'success'
//       });
//     }).catch(() => {
//       setSnackbar({
//         open: true,
//         message: 'Failed to copy link',
//         severity: 'error'
//       });
//     });
//   };

//   if (loading) return <Loader />;
  
//   if (error) {
//     return (
//       <Box sx={{ p: 3, textAlign: 'center' }}>
//         <Typography color="error" sx={outfitFontStyle}>{error}</Typography>
//       </Box>
//     );
//   }

//   return (
//     <Box
//       sx={{
//         mt: '0px',
//         mb: { xs: '100px', md: '140px' },
//         mx: 'auto',
//         px: { xs: 2, md: 2 },
//         width: '100%',
//         maxWidth: '1100px',
//         border: '2px solid #f1f1f1',
//         borderRadius: '16px',
//         background: '#fff',
//         boxSizing: 'border-box',
//         py: { xs: 4, md: 6 },
//       }}
//     >
//       <Box
//         sx={{
//           display: 'flex',
//           justifyContent: 'space-between',
//           alignItems: 'center',
//           mb: 4,
//           px: { xs: 1, md: 2 },
//         }}
//       >
//         <Typography
//           variant="h5"
//           sx={{ ...outfitFontStyle, fontWeight: 600, color: '#111827' }}
//         >
//           My Favorites ({favorites.length})
//         </Typography>
//       </Box>

//       {favorites.length === 0 ? (
//         <Box sx={{ textAlign: 'center', py: 8 }}>
//           <Typography variant="h6" color="#666" sx={outfitFontStyle}>
//             No favorites found
//           </Typography>
//           <Typography variant="body2" color="#999" sx={{ mt: 1, ...outfitFontStyle }}>
//             Add properties to your wishlist to see them here
//           </Typography>
//         </Box>
//       ) : (
//         <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 3, px: 1 }}>
//           {getCurrentPageItems().map((item) => {
//             const property = item.property;
//             const timeAgo = getTimeAgo(property.updatedAt || property.createdAt);
//             const propertyImage = getPropertyImage(property);
//             const hasImage = hasValidImage(property);
            
//             return (
//               <Box
//                 key={item.favorite_id}
//                 sx={{
//                   width: { xs: '100%', sm: 'calc(50% - 12px)', md: 'calc(33.333% - 16px)' },
//                   mb: 1
//                 }}
//               >
//                 <Card
//                   sx={{
//                     borderRadius: '12px',
//                     overflow: 'hidden',
//                     boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
//                     height: '100%',
//                     display: 'flex',
//                     flexDirection: 'column',
//                     position: 'relative',
//                     transition: 'all 0.3s ease',
//                     '&:hover': {
//                       boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
//                       transform: 'translateY(-2px)',
//                     },
//                   }}
//                 >
//                   {/* Favorite Badge */}
//                   <Box
//                     sx={{
//                       position: 'absolute',
//                       top: 10,
//                       right: 10,
//                       zIndex: 2,
//                     }}
//                   >
//                     <Button
//                       onClick={(e) => handleRemoveFavorite(property.id, e)}
//                       sx={{
//                         minWidth: 'auto',
//                         p: '6px',
//                         borderRadius: '50%',
//                         backgroundColor: 'rgba(255, 255, 255, 0.9)',
//                         '&:hover': {
//                           backgroundColor: 'rgba(255, 255, 255, 1)',
//                         },
//                       }}
//                     >
//                       <FavoriteIcon sx={{ color: '#ef4444', fontSize: 20 }} />
//                     </Button>
//                   </Box>

//                   {/* Image Container with Time Badge */}
//                   <Box sx={{ position: 'relative', width: '100%', height: '180px' }}>
//                     {hasImage && propertyImage ? (
//                       <Box
//                         component="img"
//                         src={propertyImage}
//                         alt={property.property_name || "Property"}
//                         sx={{
//                           width: '100%',
//                           height: '100%',
//                           objectFit: 'cover',
//                           backgroundColor: '#f5f5f5'
//                         }}
//                         onError={(e) => {
//                           console.error('Image failed to load:', property.property_name);
//                           e.target.style.display = 'none';
//                           e.target.parentElement.innerHTML = '<div style="width:100%;height:100%;display:flex;align-items:center;justify-content:center;background-color:#f5f5f5;border:1px dashed #ccc;"><p style="color:#888;text-align:center;padding:0 16px;font-size:14px;">No images uploaded</p></div>';
//                         }}
//                       />
//                     ) : (
//                       <Box
//                         sx={{
//                           width: '100%',
//                           height: '100%',
//                           display: 'flex',
//                           alignItems: 'center',
//                           justifyContent: 'center',
//                           backgroundColor: '#f5f5f5',
//                           border: '1px dashed #ccc'
//                         }}
//                       >
//                         <Typography variant="body2" color="#888" textAlign="center" px={2}>
//                           No images uploaded
//                         </Typography>
//                       </Box>
//                     )}

//                     {/* Time Ago Badge */}
//                     {timeAgo && (
//                       <Box
//                         sx={{
//                           position: 'absolute',
//                           bottom: '8px',
//                           left: '8px',
//                           bgcolor: 'rgba(0, 0, 0, 0.7)',
//                           color: '#fff',
//                           px: '8px',
//                           py: '4px',
//                           borderRadius: '4px',
//                           fontSize: '11px',
//                           fontWeight: 500,
//                           zIndex: 1,
//                           ...outfitFontStyle,
//                         }}
//                       >
//                         {timeAgo}
//                       </Box>
//                     )}
//                   </Box>

//                   <CardContent
//                     sx={{
//                       p: 2,
//                       flexGrow: 1,
//                       display: 'flex',
//                       flexDirection: 'column',
//                       justifyContent: 'space-between',
//                     }}
//                   >
//                     <Box>
//                       <Typography
//                         variant="h6"
//                         sx={{
//                           ...outfitFontStyle,
//                           fontWeight: 600,
//                           fontSize: '16px',
//                           mb: 0.5,
//                           lineHeight: 1.3,
//                         }}
//                       >
//                         {property.property_name || "Unnamed Property"}
//                       </Typography>

//                       <Typography
//                         variant="h6"
//                         sx={{
//                           ...outfitFontStyle,
//                           fontWeight: 700,
//                           color: '#3b82f6',
//                           mb: 1,
//                           fontSize: '18px',
//                         }}
//                       >
//                         {property.category === 'sale'
//                           ? formatCurrency(property.asking_price, property.currency)
//                           : `${formatCurrency(property.monthly_rent, property.currency)}/month`}
//                       </Typography>

//                       <Typography
//                         variant="body2"
//                         sx={{
//                           ...outfitFontStyle,
//                           color: '#6b7280',
//                           fontSize: '14px',
//                           mb: 2,
//                           lineHeight: 1.4,
//                         }}
//                       >
//                         {property.area_name || ""}, {property.location || ""}
//                       </Typography>
//                     </Box>

//                     {/* View and Share Buttons */}
//                     <Box
//                       sx={{
//                         display: 'flex',
//                         gap: 1,
//                         mb: 2,
//                       }}
//                     >
//                       <Button
//                         fullWidth
//                         variant="contained"
//                         startIcon={<VisibilityIcon />}
//                         onClick={() => handleViewProperty(property.id)}
//                         sx={{
//                           ...outfitFontStyle,
//                           textTransform: 'none',
//                           fontSize: '13px',
//                           fontWeight: 500,
//                           borderRadius: '10px',
//                           py: 0.75,
//                           backgroundColor: '#3b82f6',
//                           '&:hover': {
//                             backgroundColor: '#2563eb',
//                           },
//                         }}
//                       >
//                         View
//                       </Button>
//                       <Button
//                         fullWidth
//                         variant="outlined"
//                         startIcon={<ShareIcon />}
//                         onClick={(e) => handleShareProperty(property.id, e)}
//                         sx={{
//                           ...outfitFontStyle,
//                           textTransform: 'none',
//                           fontSize: '13px',
//                           fontWeight: 500,
//                           borderRadius: '10px',
//                           py: 0.75,
//                           borderColor: '#3b82f6',
//                           color: '#3b82f6',
//                           '&:hover': {
//                             borderColor: '#2563eb',
//                             backgroundColor: 'rgba(59, 130, 246, 0.04)',
//                           },
//                         }}
//                       >
//                         Share
//                       </Button>
//                     </Box>

//                     <Box
//                       sx={{
//                         display: 'flex',
//                         justifyContent: 'space-between',
//                         alignItems: 'center',
//                         pt: 1,
//                         borderTop: '1px solid #f3f4f6',
//                       }}
//                     >
//                       <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                         <VisibilityIcon
//                           sx={{ fontSize: 16, color: '#9ca3af', mr: 0.5 }}
//                         />
//                         <Typography
//                           variant="caption"
//                           sx={{
//                             ...outfitFontStyle,
//                             color: '#6b7280',
//                             fontSize: '12px',
//                             fontWeight: 500,
//                           }}
//                         >
//                           0 Views
//                         </Typography>
//                       </Box>
//                       <Typography
//                         variant="caption"
//                         sx={{
//                           ...outfitFontStyle,
//                           color: '#9ca3af',
//                           fontSize: '11px',
//                         }}
//                       >
//                         Property ID: #PD{property.id.toString().padStart(6, '0')}
//                       </Typography>
//                     </Box>
//                   </CardContent>
//                 </Card>
//               </Box>
//             );
//           })}
//         </Box>
//       )}

//       {/* Pagination */}
//       {totalPages > 1 && (
//         <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 6, pr: { xs: 2, md: 4 } }}>
//           <Pagination
//             count={totalPages}
//             page={page}
//             onChange={handlePageChange}
//             color="primary"
//             size="large"
//             sx={{
//               '& .MuiPaginationItem-root': {
//                 ...outfitFontStyle,
//                 fontWeight: 500,
//               },
//             }}
//           />
//         </Box>
//       )}

//       {/* Snackbar Notification */}
//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={4000}
//         onClose={handleCloseSnackbar}
//         anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
//       >
//         <Alert 
//           onClose={handleCloseSnackbar} 
//           severity={snackbar.severity}
//           sx={{ width: '100%', ...outfitFontStyle }}
//         >
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// };

// export default ProfileWish;


import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Pagination,
  Button,
  Card,
  CardContent,
  Snackbar,
  Alert,
} from '@mui/material';
import { useSelector } from 'react-redux';
import axios from 'axios';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ShareIcon from '@mui/icons-material/Share';
import FavoriteIcon from '@mui/icons-material/Favorite';
import Loader from '../../../Loader/Loader';
import { selectUser } from '../../../Commonlibs/userSlice';
import { useNavigate } from 'react-router-dom';

const outfitFontStyle = {
  fontFamily: 'Outfit, sans-serif',
};

const ProfileWish = () => {
  const [favorites, setFavorites] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success'
  });
  
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const itemsPerPage = 6;
  
  const navigate = useNavigate();
  const user = useSelector(selectUser);
  const buyerId = user?.id;

  // ✅ Helper function to check if error is network-related
  const isNetworkError = (error) => {
    const errorString = error?.toString().toLowerCase() || '';
    return (
      errorString.includes('network') ||
      errorString.includes('fetch') ||
      errorString.includes('connection') ||
      errorString.includes('timeout') ||
      error?.message?.toLowerCase().includes('network') ||
      error?.code === 'ERR_NETWORK' ||
      error?.code === 'ECONNABORTED'
    );
  };

  // ✅ Updated fetchFavorites with better error handling
  useEffect(() => {
    const fetchFavorites = async () => {
      if (!buyerId) {
        setLoading(false);
        return;
      }
      
      try {
        setLoading(true);
        setError(null);
        const response = await axios.get(
          `https://propertydealstalk.com/api/buyer/getFavoritesByBuyerId?buyer_id=${buyerId}`
        );
        
        if (response.data.statusCode === 200) {
          const sortedFavorites = response.data.result.sort((a, b) => {
            const dateA = new Date(b.property?.updatedAt || b.property?.createdAt || 0);
            const dateB = new Date(a.property?.updatedAt || a.property?.createdAt || 0);
            return dateA - dateB;
          });
          
          setFavorites(sortedFavorites);
          setTotalPages(Math.ceil(sortedFavorites.length / itemsPerPage));
        } else {
          setError(response.data.message || 'Failed to fetch favorites');
        }
      } catch (err) {
        console.error('Error fetching favorites:', err);
        // Show user-friendly message for all GET request errors
        setError('Unable to load your favorites. Please check your internet connection and try again.');
      } finally {
        setLoading(false);
      }
    };
    fetchFavorites();
  }, [buyerId]);

  const hasValidImage = (property) => {
    if (!property) return false;
    
    if (property.primary_image && 
        property.primary_image.length > 50 &&
        property.primary_image.startsWith('/9j/')) {
      return true;
    }

    if (property.image && 
        property.image.length > 50 && 
        !property.image.startsWith('iVBORw0KGgo')) {
      return true;
    }

    if (property.images) {
      if (typeof property.images === 'string' && property.images.length > 50) {
        return true;
      }
      if (Array.isArray(property.images) && property.images.length > 0) {
        return true;
      }
    }

    return false;
  };

  const getPropertyImage = (property) => {
    if (!property) return null;
    
    if (property.primary_image && property.primary_image.length > 50) {
      if (property.primary_image.startsWith('data:image')) {
        return property.primary_image;
      }
      return `data:image/jpeg;base64,${property.primary_image}`;
    }

       if (property.image && 
        property.image.length > 50 && 
        !property.image.startsWith('iVBORw0KGgo')) {
      if (property.image.startsWith('data:image')) {
        return property.image;
      }
      return `data:image/jpeg;base64,${property.image}`;
    }

    if (property.images) {
      if (typeof property.images === 'string' && property.images.length > 50) {
        if (property.images.startsWith('data:image')) {
          return property.images;
        }
        return `data:image/jpeg;base64,${property.images}`;
      }
      if (Array.isArray(property.images) && property.images.length > 0) {
        const firstImage = property.images[0];
        if (firstImage.startsWith('data:image')) {
          return firstImage;
        }
        return `data:image/jpeg;base64,${firstImage}`;
      }
    }

    return null;
  };

  const getTimeAgo = (dateString) => {
    if (!dateString) return '';
    
    const date = new Date(dateString);
    const now = new Date();
    const diffInSeconds = Math.floor((now - date) / 1000);
    
    const intervals = {
      y: 31536000,
      mo: 2592000,
      w: 604800,
      d: 86400,
      h: 3600,
      m: 60,
      s: 1
    };
    
    for (const [key, value] of Object.entries(intervals)) {
      const interval = Math.floor(diffInSeconds / value);
      if (interval >= 1) {
        return `${interval}${key} ago`;
      }
    }
    
    return 'just now';
  };

  // ✅ Updated handleRemoveFavorite with better error handling
  const handleRemoveFavorite = async (propertyId, event) => {
    event.stopPropagation();
    
    try {
      const response = await axios.post(
        'https://www.propertydealstalk.com/api/buyer/removeFavorite',
        {
          buyer_id: buyerId,
          property_id: propertyId
        }
      );
      
      if (response.data.statusCode === 200) {
        const updatedFavorites = favorites.filter(
          item => item.property.id !== propertyId
        );
        setFavorites(updatedFavorites);
        
        const newTotalPages = Math.ceil(updatedFavorites.length / itemsPerPage);
        setTotalPages(newTotalPages);
        
        if (page > newTotalPages && page > 1) {
          setPage(newTotalPages);
        }
        
        setSnackbar({
          open: true,
          message: 'Property removed from favorites successfully',
          severity: 'success'
        });
      } else {
        // Show actual API error message
        throw new Error(response.data.message || 'Failed to remove property from favorites');
      }
    } catch (err) {
      console.error('Error removing favorite:', err);
      // Check if it's a network error or API error
      const errorMessage = isNetworkError(err)
        ? 'Unable to remove from favorites. Please check your connection and try again.'
        : err.message || 'Failed to remove from favorites';
      
      setSnackbar({
        open: true,
        message: errorMessage,
        severity: 'error'
      });
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const getCurrentPageItems = () => {
    const startIndex = (page - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return favorites.slice(startIndex, endIndex);
  };

  const handlePageChange = (event, value) => {
    setPage(value);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const formatCurrency = (amount, currency = '₹') => {
    if (!amount) return null;
    return `${currency}${Number(amount).toLocaleString()}`;
  };

  const handleViewProperty = (propertyId) => {
    navigate(`/view/${propertyId}`);
  };

  const handleShareProperty = (propertyId, event) => {
    event.stopPropagation();
    const publicUrl = `${window.location.origin}/view/${propertyId}?shared=true`;
    
    navigator.clipboard.writeText(publicUrl).then(() => {
      setSnackbar({
        open: true,
        message: 'Property link copied to clipboard!',
        severity: 'success'
      });
    }).catch(() => {
      setSnackbar({
        open: true,
        message: 'Failed to copy link',
        severity: 'error'
      });
    });
  };

  if (loading) return <Loader />;
  
  if (error) {
    return (
      <Box 
        sx={{ 
          display: 'flex', 
          flexDirection: 'column',
          justifyContent: 'center', 
          alignItems: 'center', 
          minHeight: '400px',
          p: 4,
          textAlign: 'center'
        }}
      >
        <Typography 
          sx={{ 
            color: '#666',
            fontSize: '1.1rem',
            fontWeight: 500,
            maxWidth: '600px',
            ...outfitFontStyle
          }}
        >
          {error}
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        mt: '0px',
        mb: { xs: '100px', md: '140px' },
        mx: 'auto',
        px: { xs: 2, md: 2 },
        width: '100%',
        maxWidth: '1100px',
        border: '2px solid #f1f1f1',
        borderRadius: '16px',
        background: '#fff',
        boxSizing: 'border-box',
        py: { xs: 4, md: 6 },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 4,
          px: { xs: 1, md: 2 },
        }}
      >
        <Typography
          variant="h5"
          sx={{ ...outfitFontStyle, fontWeight: 600, color: '#111827' }}
        >
          My Favorites ({favorites.length})
        </Typography>
      </Box>

      {favorites.length === 0 ? (
        <Box sx={{ textAlign: 'center', py: 8 }}>
          <Typography variant="h6" color="#666" sx={outfitFontStyle}>
            No favorites found
          </Typography>
          <Typography variant="body2" color="#999" sx={{ mt: 1, ...outfitFontStyle }}>
            Add properties to your wishlist to see them here
          </Typography>
        </Box>
      ) : (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 3, px: 1 }}>
          {getCurrentPageItems().map((item) => {
            const property = item.property;
            const timeAgo = getTimeAgo(property.updatedAt || property.createdAt);
            const propertyImage = getPropertyImage(property);
            const hasImage = hasValidImage(property);
            
            return (
              <Box
                key={item.favorite_id}
                sx={{
                  width: { xs: '100%', sm: 'calc(50% - 12px)', md: 'calc(33.333% - 16px)' },
                  mb: 1
                }}
              >
                <Card
                  sx={{
                    borderRadius: '12px',
                    overflow: 'hidden',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    position: 'relative',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
                      transform: 'translateY(-2px)',
                    },
                  }}
                >
                  <Box
                    sx={{
                      position: 'absolute',
                      top: 10,
                      right: 10,
                      zIndex: 2,
                    }}
                  >
                    <Button
                      onClick={(e) => handleRemoveFavorite(property.id, e)}
                      sx={{
                        minWidth: 'auto',
                        p: '6px',
                        borderRadius: '50%',
                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                        '&:hover': {
                          backgroundColor: 'rgba(255, 255, 255, 1)',
                        },
                      }}
                    >
                      <FavoriteIcon sx={{ color: '#ef4444', fontSize: 20 }} />
                    </Button>
                  </Box>

                  <Box sx={{ position: 'relative', width: '100%', height: '180px' }}>
                    {hasImage && propertyImage ? (
                      <Box
                        component="img"
                        src={propertyImage}
                        alt={property.property_name || "Property"}
                        sx={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover',
                          backgroundColor: '#f5f5f5'
                        }}
                        onError={(e) => {
                          console.error('Image failed to load:', property.property_name);
                          e.target.style.display = 'none';
                          e.target.parentElement.innerHTML = '<div style="width:100%;height:100%;display:flex;align-items:center;justify-content:center;background-color:#f5f5f5;border:1px dashed #ccc;"><p style="color:#888;text-align:center;padding:0 16px;font-size:14px;">No images uploaded</p></div>';
                        }}
                      />
                    ) : (
                      <Box
                        sx={{
                          width: '100%',
                          height: '100%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          backgroundColor: '#f5f5f5',
                          border: '1px dashed #ccc'
                        }}
                      >
                        <Typography variant="body2" color="#888" textAlign="center" px={2}>
                          No images uploaded
                        </Typography>
                      </Box>
                    )}

                    {timeAgo && (
                      <Box
                        sx={{
                          position: 'absolute',
                          bottom: '8px',
                          left: '8px',
                          bgcolor: 'rgba(0, 0, 0, 0.7)',
                          color: '#fff',
                          px: '8px',
                          py: '4px',
                          borderRadius: '4px',
                          fontSize: '11px',
                          fontWeight: 500,
                          zIndex: 1,
                          ...outfitFontStyle,
                        }}
                      >
                        {timeAgo}
                      </Box>
                    )}
                  </Box>

                  <CardContent
                    sx={{
                      p: 2,
                      flexGrow: 1,
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'space-between',
                    }}
                  >
                    <Box>
                      <Typography
                        variant="h6"
                        sx={{
                          ...outfitFontStyle,
                          fontWeight: 600,
                          fontSize: '16px',
                          mb: 0.5,
                          lineHeight: 1.3,
                        }}
                      >
                        {property.property_name || "Unnamed Property"}
                      </Typography>

                      <Typography
                        variant="h6"
                        sx={{
                          ...outfitFontStyle,
                          fontWeight: 700,
                          color: '#3b82f6',
                          mb: 1,
                          fontSize: '18px',
                        }}
                      >
                        {property.category === 'sale'
                          ? formatCurrency(property.asking_price, property.currency)
                          : `${formatCurrency(property.monthly_rent, property.currency)}/month`}
                      </Typography>

                      <Typography
                        variant="body2"
                        sx={{
                          ...outfitFontStyle,
                          color: '#6b7280',
                          fontSize: '14px',
                          mb: 2,
                          lineHeight: 1.4,
                        }}
                      >
                        {property.area_name || ""}, {property.location || ""}
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        display: 'flex',
                        gap: 1,
                        mb: 2,
                      }}
                    >
                      <Button
                        fullWidth
                        variant="contained"
                        startIcon={<VisibilityIcon />}
                        onClick={() => handleViewProperty(property.id)}
                        sx={{
                          ...outfitFontStyle,
                          textTransform: 'none',
                          fontSize: '13px',
                          fontWeight: 500,
                          borderRadius: '10px',
                          py: 0.75,
                          backgroundColor: '#3b82f6',
                          '&:hover': {
                            backgroundColor: '#2563eb',
                          },
                        }}
                      >
                        View
                      </Button>
                      <Button
                        fullWidth
                        variant="outlined"
                        startIcon={<ShareIcon />}
                        onClick={(e) => handleShareProperty(property.id, e)}
                        sx={{
                          ...outfitFontStyle,
                          textTransform: 'none',
                          fontSize: '13px',
                          fontWeight: 500,
                          borderRadius: '10px',
                          py: 0.75,
                          borderColor: '#3b82f6',
                          color: '#3b82f6',
                          '&:hover': {
                            borderColor: '#2563eb',
                            backgroundColor: 'rgba(59, 130, 246, 0.04)',
                          },
                        }}
                      >
                        Share
                      </Button>
                    </Box>

                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        pt: 1,
                        borderTop: '1px solid #f3f4f6',
                      }}
                    >
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <VisibilityIcon
                          sx={{ fontSize: 16, color: '#9ca3af', mr: 0.5 }}
                        />
                        <Typography
                          variant="caption"
                          sx={{
                            ...outfitFontStyle,
                            color: '#6b7280',
                            fontSize: '12px',
                            fontWeight: 500,
                          }}
                        >
                          0 Views
                        </Typography>
                      </Box>
                      <Typography
                        variant="caption"
                        sx={{
                          ...outfitFontStyle,
                          color: '#9ca3af',
                          fontSize: '11px',
                        }}
                      >
                        Property ID: #PD{property.id.toString().padStart(6, '0')}
                      </Typography>
                    </Box>
                  </CardContent>
                </Card>
              </Box>
            );
          })}
        </Box>
      )}

      {totalPages > 1 && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 6, pr: { xs: 2, md: 4 } }}>
          <Pagination
            count={totalPages}
            page={page}
            onChange={handlePageChange}
            color="primary"
            size="large"
            sx={{
              '& .MuiPaginationItem-root': {
                ...outfitFontStyle,
                fontWeight: 500,
              },
            }}
          />
        </Box>
      )}

      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert 
          onClose={handleCloseSnackbar} 
          severity={snackbar.severity}
          sx={{ width: '100%', ...outfitFontStyle }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default ProfileWish;

